import { css } from '@emotion/react';
import { theme } from 'global';

export const abnInput = css`
  background-color: ${theme.colors.white};

  .MuiInputAdornment-root {
    display: inline;
  }
`;

export const hasAISuggestion = css`
  margin-bottom: 0.5rem !important;
`;

export const select = css`
  width: 100%;
`;

export const loadingSkeletonGif = css`
  width: 100%;
  object-fit: cover;
  margin-bottom: 1.25rem;
  display: block;
`;

export const tooltipContent = css`
  margin: 0;
  padding: 0.5rem;
`;
